import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { useReactNodeView } from '@lyearn/lygo-core';
import { Typography } from '@lyearn/ui';

import useResizableTextArea from '../../hooks/useResizableTextArea';
import { CaptionProps } from './types';

const stopPropagation = (
  event: React.KeyboardEvent | React.SyntheticEvent<HTMLTextAreaElement, Event>,
) => {
  event.stopPropagation();
};

const onKeyDown = (event: React.KeyboardEvent) => {
  if (event.key === 'Enter') {
    event.preventDefault();
  }
  event.stopPropagation();
};

const Caption: React.FC<CaptionProps> = (props) => {
  let { readOnly, caption } = props;
  const { textAreaInputRef } = useResizableTextArea(caption);
  const { updateAttrs } = useReactNodeView();
  const { t } = useTranslation();

  const onChange = React.useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      updateAttrs({ caption: event.target.value });
    },
    [updateAttrs],
  );

  return (
    <div className="flex pt-12 -ms-16">
      {readOnly
        ? caption && (
            <Typography
              className="w-full text-center italic text-text-secondary"
              variant="body-short-02">
              {caption}
            </Typography>
          )
        : caption !== null && (
            <textarea
              ref={textAreaInputRef}
              autoFocus
              className="body-short-02 w-full resize-none text-center italic text-text-secondary outline-none"
              placeholder={t('Lygo:AddCaption')}
              value={caption || ''}
              onInput={onChange}
              onKeyDown={onKeyDown}
              onKeyPress={stopPropagation}
              onPaste={stopPropagation}
              onSelect={stopPropagation}
            />
          )}
    </div>
  );
};

export default Caption;
